import { useSpacesContext } from "@circle-react/contexts";
import { usePunditUserContext } from "@circle-react/contexts";

export const useCanCreatePost = () => {
  const { helpers: spaceHelpers } = useSpacesContext();
  const { currentCommunityMember } = usePunditUserContext();

  const spacesAllowedLength =
    spaceHelpers.spacesWithPostCreationAllowed().length;

  const canCreatePost = Boolean(currentCommunityMember && spacesAllowedLength);

  return {
    canCreatePost,
  };
};
